import type { FC } from 'react';

import { ReactComponent as Simbolo } from './maestra-symbol.svg';
import { ReactComponent as Palavra } from './maestra-wordmark.svg';
import styles from './MarcaMaestra.module.scss';

// A MARCA DA MAESTRA: os vetores oficiais, pintados com a cor do texto do tema (currentColor).
// `simbolo` é o monograma sozinho; `completa` é o monograma com o nome.

export const MarcaMaestra: FC<{ forma?: 'simbolo' | 'completa'; className?: string }> = ({ forma = 'completa', className }) => (
  <span className={[styles.marca, className].filter(Boolean).join(' ')} role='img' aria-label='Maestra'>
    <Simbolo className={styles.simbolo} aria-hidden focusable='false' />
    {forma === 'completa' && <Palavra className={styles.palavra} aria-hidden focusable='false' />}
  </span>
);
